module.exports = __webpack_public_path__ + "static/img/thumb_61.8dd206e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_61.jpg
// module id = pH2M
// module chunks = 0